import { ref } from '@vue/composition-api';

const rejectNotificationDialog = ref(false);
const inofficeInterviewDialog = ref(false);
const jobOfferDialog = ref(false);
const inviteMethodDialog = ref(false);
const recordOfficeInterviewDialog = ref(false);
const createCandidateDialog = ref(false);
const createVideoCallDialog = ref(false);

export default function useKanbanDialogs(clear = false) {
  if (clear) {
    rejectNotificationDialog.value = false;
    inofficeInterviewDialog.value = false;
    jobOfferDialog.value = false;
    inviteMethodDialog.value = false;
    createCandidateDialog.value = false;
    recordOfficeInterviewDialog.value = false;
    createVideoCallDialog.value = false;
  }
  return {
    rejectNotificationDialog,
    inviteMethodDialog,
    inofficeInterviewDialog,
    jobOfferDialog,
    recordOfficeInterviewDialog,
    createCandidateDialog,
    createVideoCallDialog,
  };
}
